import GeniePage from "../../../components/special/genie-page/GeniePage";
import GenieText from "../../../components/core/genie-text/GenieText";
import Box from "@mui/material/Box";
import {
  Chip,
  IconButton,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
} from "@mui/material";
import React, { useState } from "react";
import GenieStickyHeader from "../../../components/core/genie-sticky-header/GenieStickyHeader";
import { useParams } from "react-router-dom";
import useAdminOrders from "../../../queries/routes/useAdminOrders";
import { formatCurrency } from "../../../utils/currency";
import { readableDateTime } from "../../../utils/date";
import GenieEmpty from "../../../components/core/genie-empty/GenieEmpty";
import GenieTableLoad from "../../../components/core/genie-table-load/GenieTableLoad";
import { Add, Edit } from "@mui/icons-material";
import { Order as OrderType } from "../../../types/api/Order";
import AddShippingDialog from "./AddShippingDialog";
import OrderImport from "../../../components/special/order-import/OrderImport";

function Order() {
  const { org_id } = useParams();
  const { data: orders, isLoading } = useAdminOrders(org_id!);
  const [trackingOrder, setTrackingOrder] = useState<OrderType | null>(null);
  const [dialogOpen, setDialogOpen] = useState(false);

  function setClosed() {
    setDialogOpen(false);
  }

  return (
    <GeniePage noMargin>
      <AddShippingDialog
        order={trackingOrder}
        open={dialogOpen}
        setClosed={setClosed}
      />
      <GenieStickyHeader>
        <Stack
          flexDirection={"row"}
          width={"100%"}
          alignItems={"center"}
          justifyContent={"space-between"}
        >
          <GenieText fontSize={"medium"} fontWeight={"bold"}>
            Orders
          </GenieText>
          <OrderImport organizationId={org_id!} />
        </Stack>
      </GenieStickyHeader>
      <Box mt={4}>
        {isLoading && (
          <GenieTableLoad
            rowCount={10}
            columnCount={5}
            sx={{ minWidth: 650 }}
          />
        )}
        {!isLoading && orders?.length === 0 && (
          <GenieEmpty>Orders haven't been added or received yet</GenieEmpty>
        )}
        {!isLoading && orders && orders.length > 0 && (
          <TableContainer component={Box}>
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell align="left">Date</TableCell>
                  <TableCell align="left">Customer</TableCell>
                  <TableCell align="right">Amount</TableCell>
                  <TableCell align="right">Shipping Cost</TableCell>
                  <TableCell align="right">Shipped?</TableCell>
                  <TableCell align="right">Payment Status</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {orders?.map((order) => (
                  <TableRow
                    key={order.id}
                    sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                  >
                    <TableCell component="th" scope="row" align={"left"}>
                      {readableDateTime(order.completed_on)}
                    </TableCell>
                    <TableCell component="th" scope="row" align={"left"}>
                      {order.organization.name}
                    </TableCell>
                    <TableCell align="right">
                      {formatCurrency(order.cart.total_cents)}
                    </TableCell>
                    <TableCell align="right">
                      {formatCurrency(order.shipping_cost_in_cents || 0)}
                    </TableCell>
                    <TableCell align="right">
                      {order?.imported_order_data ?
                        (order.imported_order_data.fulfillment_status === "fulfilled" ? "Yes" : "No") :
                        (order?.shipping_information?.status ? "Yes" : "No")
                      }
                      {!order?.imported_order_data && (
                        <Tooltip
                          title={`${
                            order?.shipping_information ? "Edit" : "Add"
                          } Tracking Number`}
                        >
                          <IconButton
                            sx={{ ml: 1 }}
                            aria-label="delete"
                            size="small"
                            onClick={() => {
                              setDialogOpen(true);
                              setTrackingOrder(order);
                            }}
                          >
                            {order?.shipping_information ? (
                              <Edit fontSize={"small"} color={"primary"} />
                            ) : (
                              <Add fontSize={"small"} color={"primary"} />
                            )}
                          </IconButton>
                        </Tooltip>
                      )}
                    </TableCell>
                    <TableCell align="right">
                      <Chip
                        label={
                          order.invoice?.stripe_status?.toUpperCase() || "N/A"
                        }
                        variant={"outlined"}
                        color={
                          order.invoice?.stripe_status?.toUpperCase() !== "OPEN"
                            ? "primary"
                            : "error"
                        }
                      />
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </Box>
    </GeniePage>
  );
}

export default Order;
